import { connect } from "react-redux";
import AddressList from "./components";
import {
  getUserAddresses,
  deleteAddress,
  changeCheckoutForm,
  setDefaultUserAddress,
  setDbUserFreeLimitByAddress,
} from "../../../../actions";

function mapDispatchToProps(dispatch) {
  return {
    updateDbUser: (address) => {
      dispatch(setDbUserFreeLimitByAddress(address));
    },
    getUserAddresses: (userId, token) => {
      dispatch(getUserAddresses(userId, token));
    },
    deleteAddress: (addressId) => {
      dispatch(deleteAddress(addressId));
    },
    changeCheckoutForm: (contact) => {
      dispatch(changeCheckoutForm(contact));
    },
    setDefaultUserAddress: (token, userId, addressId, isForeign) => {
      dispatch(setDefaultUserAddress(token, userId, addressId, isForeign));
    },
  };
}

const mapStateToProps = (state) => ({
  token: state.user.token,
  dbUser: state.user.dbUser,
  addresses: state.user.addresses,
  checkoutForm: state.cart.checkoutForm,
  settings: state.settings.cartSettings,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressList);
